import { Alert } from './models/alert';
import * as actions from './actions';
import _cloneDeep from 'lodash/cloneDeep';

const initialState = () => {
    return {
        items: []
    };
};

export default function(state = initialState(), action) {
    switch (action.type) {
        case actions.SET_ALERT: {
            const { alert } = action.value;
            const alerts = _cloneDeep(state.items);
            alerts.push(alert);
            return {
                ...state,
                items: alerts
            };
        }

        case actions.REMOVE_ALERT: {
            const { alert } = action.value;
            const alerts = _cloneDeep(state.items);
            const index = alerts.findIndex(item => item.id === alert.id);

            if (index > -1) {
                alerts.splice(index, 1);
            }

            return {
                ...state,
                items: alerts
            };
        }

        case actions.REMOVE_ALL_ALERTS: {
            return {
                ...state,
                items: []
            };
        }
        default:
            return state;
    }
}
